export default __webpack_public_path__ + "static/Piercing-d9776f7c314fd7ee47f63251e2574959.png";